import React, { useState, useEffect, useContext, useRef } from 'react'
import { setConfig } from 'react-hot-loader'
import { AccessTokenContext } from 'providers/AccessToken'
import { getFormData } from 'api/request'
import useSignUpData from 'hooks/useSignUpData'

setConfig({ pureSFC: true })

export const FormDataContext = React.createContext()

const FormDataProvider = ({ children }) => {
  const [defaultData] = useSignUpData()
  const [signUpData, updateSignUpData] = useState(defaultData)

  const [formData, setFormData] = useState(null)
  const [loading, setLoading] = useState(true)
  const { token } = useContext(AccessTokenContext)
  let isMounted = useRef(false)
  useEffect(() => {
    isMounted.current = true
    token &&
      getFormData(token)
        .then(token => {
          if (isMounted.current) {
            setFormData(token)
          }
        })
        .then(() => {
          if (isMounted.current) {
            setLoading(false)
          }
        })
        .catch(err => console.log('err', err))
    return () => {
      isMounted.current = false
    }
  }, [token, loading])

  return (
    <FormDataContext.Provider
      value={{ formData, loading, signUpData, updateSignUpData }}
    >
      {children}
    </FormDataContext.Provider>
  )
}

export default FormDataProvider
